import React from "react";
import Interval from "react-interval-rerender";
import withTranslations from "../../../../../hocs/withTranslations";
import ConfirmationDateHelper from "../../../../../lib/UniversalTable/RendererHelpers/ConfirmationDateHelper";
import DateHelper from "../../../../../lib/UniversalTable/RendererHelpers/DateHelper";
import { TrendStatusArrow } from "../components/TrendStatusArrows/TrendStatusArrows";
import "../rendererStyles/Date.scss";

const ConfirmationDate = ({ value, format, translate, resultMetaData }) => {
  const eventArrow = ConfirmationDateHelper.getEventArrow(
    resultMetaData && resultMetaData.event_type
  );

  return (
    <div className="date-renderer">
      {eventArrow ? <TrendStatusArrow {...eventArrow} /> : null}
      <Interval delay={60 * 1000}>
        {() => DateHelper.render(value, format, translate)}
      </Interval>
    </div>
  );
};

export default withTranslations(ConfirmationDate);
